import { setUpModernPage } from 'js/simple_layout/set_up_modern_page';
import React from 'react';
import Home from 'js/social/Home';
import registerForRails from 'js/utils/registerForRails';
import CiterightSimple from 'js/citeright/CiterightSimple';
import CiterightInline from 'js/citeright/CiterightInline';
import CiterightPreprintReport from 'js/citeright/CiterightPreprintReport';
import CiterightLanding from 'js/citeright/CiterightLanding';
import CiterightMiniReport from 'js/citeright/CiterightMiniReport';
import ReferenceEvaluationPage from 'js/citeright/ReferenceEvaluationPage';
import EvaluatePublicationFinderPage from 'js/citeright/EvaluatePublicationFinderPage';
import { ToastProvider } from 'js/design_system/toasts/ToastProvider';
import { startRecordingIfSamplingRequest } from 'js/fullstory';

setUpModernPage();
startRecordingIfSamplingRequest();

const CiterightSimpleWithContext = () => (
  <ToastProvider>
    <CiterightSimple />
  </ToastProvider>
);

const CiterightInlineWithContext = (
  props: React.ComponentProps<typeof CiterightInline>,
) => (
  <ToastProvider>
    <CiterightInline {...props} />
  </ToastProvider>
);

const ReferenceEvaluationPageWithContext = (
  props: React.ComponentProps<typeof ReferenceEvaluationPage>,
) => (
  <ToastProvider>
    <ReferenceEvaluationPage {...props} />
  </ToastProvider>
);

const CiterightPreprintReportWithContext = (
  props: React.ComponentProps<typeof CiterightPreprintReport>,
) => (
  <ToastProvider>
    <CiterightPreprintReport {...props} />
  </ToastProvider>
);

registerForRails({
  CiterightSimple: CiterightSimpleWithContext,
  CiterightInline: CiterightInlineWithContext,
  CiterightLanding,
  CiterightMiniReport,
  ReferenceEvaluationPage: ReferenceEvaluationPageWithContext,
  EvaluatePublicationFinderPage,
  CiterightPreprintReport: CiterightPreprintReportWithContext,
  Home,
});
